import { api } from '@/services/api/AxiosBaseService'
import type { PaginatedResponse } from '@/types/api'
import type { ServiceProvider } from './ServiceProvidersService'

/**
 * Serviços (Consultas & Exames, Odontologia, Funeral). Cada serviço carrega
 * a lista de prestadores HABILITADOS — escolhidos via multi-select no form.
 * No produto, a escolha do prestador é feita sempre dentre os habilitados.
 */
export interface Service {
  id: string
  name: string
  description?: string | null
  sortOrder?: number
  status: 'ATIVO' | 'INATIVO'
  providers?: ServiceProvider[]
}

export interface ServiceWritePayload {
  name?: string
  description?: string | null
  sort_order?: number
  status?: 'ATIVO' | 'INATIVO'
  provider_ids?: string[]
}

export const ServicesService = {
  async list(params: Record<string, unknown> = {}): Promise<PaginatedResponse<Service>> {
    const r = await api.get<PaginatedResponse<Service>>('/settings/services', { params })
    return r.data
  },
  async show(id: string): Promise<Service> {
    const r = await api.get<{ data: Service }>(`/settings/services/${id}`)
    return r.data.data
  },
  async create(payload: ServiceWritePayload): Promise<Service> {
    const r = await api.post<{ data: Service }>('/settings/services', payload)
    return r.data.data
  },
  async update(id: string, payload: ServiceWritePayload): Promise<Service> {
    const r = await api.put<{ data: Service }>(`/settings/services/${id}`, payload)
    return r.data.data
  },
  async destroy(id: string): Promise<void> {
    await api.delete(`/settings/services/${id}`)
  },
  async updateStatus(id: string, status: 'ATIVO' | 'INATIVO'): Promise<Service> {
    const r = await api.put<{ data: Service }>(`/settings/services/${id}/status`, { status })
    return r.data.data
  },
}
